// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__33pgH","rootSuccess":"CompleteLink_rootSuccess__3HQwi","rootFailure":"CompleteLink_rootFailure__299WQ","isDisabled":"CompleteLink_isDisabled__3m5nS"};